import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@core/http-legacy';

import {
  AssignMatchPayload,
  AssignMatchResponse,
  JobMatchesEntity,
  MatchingGeneration,
} from './job-matching-placements.types';

@Injectable({
  providedIn: 'root',
})
export class JobMatchingPlacementsHttpService {
  private readonly httpApi = inject(HttpApiService);

  public fetch$(jobId: number): Observable<JobMatchesEntity> {
    return this.httpApi.get(`intelligence/hire_assistant/offers/${jobId}/candidate_matching`).pipe(
      map(response => ({
        matches: response.matchings,
        generation: response.generation,
        jobId,
      })),
    );
  }

  public generate$(jobId: number): Observable<{ generation: MatchingGeneration }> {
    return this.httpApi
      .post(`intelligence/hire_assistant/offers/${jobId}/candidate_matching/generate`)
      .pipe(
        map(response => ({
          generation: response.generation,
        })),
      );
  }

  public dismiss$(jobId: number, matchId: number): Observable<void> {
    return this.httpApi.patch(
      `intelligence/hire_assistant/offers/${jobId}/candidate_matching/${matchId}/dismiss`,
    );
  }

  public assign$(
    jobId: number,
    matchId: number,
    payload: AssignMatchPayload,
  ): Observable<AssignMatchResponse> {
    return this.httpApi.patch(
      `intelligence/hire_assistant/offers/${jobId}/candidate_matching/${matchId}/assign`,
      payload,
    );
  }

  public bulkAssign$(jobId: number): Observable<{ uuid: string }> {
    return this.httpApi.post(
      `intelligence/hire_assistant/offers/${jobId}/candidate_matching/bulk_assign`,
    );
  }
}
